import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { profileURL, teacherURL } from "../../Hooks/URL";
import { userContext } from "../../Contexts/userContext";
import AddTeacher from "../../Templates/Teachers/AddTeacher/AddTeacher";
import useFetchWhen from "../../Hooks/useFetchWhen";

function AddTeacherPage({ Edit = false, EditSelf = false }) {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();
  let { id } = useParams();
  const url = `${teacherURL}/${id}`;
  const { data, loading, error } = useFetchWhen(
    EditSelf ? `${profileURL}/teacher` : url,
    (Edit && (contextData?.role == "admin" || contextData?.role == "school")) ||
      (EditSelf && contextData?.role == "teacher")
  );
  const [teacher, setTeacher] = useState("");

  useEffect(() => {
    if (!loading && !error && data) {
      setTeacher(data?.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "instructors", data: "" });
  }, []);

  return (
    <AddTeacher
      Edit={Edit || EditSelf}
      teacher={teacher}
      loading={loading || teacher == ""}
      url={url}
      EditSelf={EditSelf}
    />
  );
}

export default AddTeacherPage;
